<template>
  <div>
    <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('privacy') }}
    </h1>
    <span v-if="lang_Mix == 'arabic'">
      <privacy-arabic/>
    </span>
    <span v-else-if="lang_Mix == 'malay'">
      <privacy-malay/>
    </span>
    <span v-else-if="lang_Mix == 'greek'">
      <privacy-greek/>
    </span>
    <span v-else-if="lang_Mix == 'czech'">
      <privacy-czech/>
    </span>
    <span v-else-if="lang_Mix == 'bulgarian'">
      <privacy-bulgarian/>
    </span>
    <span v-else-if="lang_Mix == 'norwegian'">
      <privacy-norwegian/>
    </span>
    <span v-else-if="lang_Mix == 'slovakia'">
        <privacy-slovakian/>
    </span>
    <span v-else-if="country_Mix == 'sk' && lang_Mix == 'english'">
        <privacy-skenglish/>
    </span>
    <span v-else-if="lang_Mix == 'swedish'">
        <privacy-swedish/>
    </span>
    <span v-else-if="lang_Mix == 'finnish'">
      <privacy-finnish/>
    </span>
    <span v-else-if="lang_Mix == 'romanian'">
      <privacy-romanian/>
    </span>
    <span v-else>
      <privacy-english/>
    </span>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from './../PrivacyPolicyEnglish';
import PrivacyPolicyArabic from './../PrivacyPolicyArabic';
import PrivacyPolicyMalay from './../PrivacyPolicyMalay';
import PrivacyPolicyGreek from './../PrivacyPolicyGreek';
import PrivacyPolicyCzech from './../PrivacyPolicyCzech';
import PrivacyPolicyBulgarian from './../PrivacyPolicyBulgarian';
import PrivacyPolicyNorwegian from './../PrivacyPolicyNorwegian';
import PrivacyPolicySlovakian from './../PrivacyPolicySlovakian';
import PrivacyPolicySKEnglish from './../PrivacyPolicySKEnglish';
import PrivacyPolicySwedish from './../PrivacyPolicySwedish';
import PrivacyPolicyFinnish from './../PrivacyPolicyFinnish';
import PrivacyPolicyRomanian from './../PrivacyPolicyRomanian';
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["lang_Mix", "country_Mix"]),
  components:{
    'privacy-english': PrivacyPolicyEnglish,
    'privacy-arabic': PrivacyPolicyArabic,
    'privacy-malay': PrivacyPolicyMalay,
    'privacy-greek': PrivacyPolicyGreek,
    'privacy-czech': PrivacyPolicyCzech,
    'privacy-bulgarian': PrivacyPolicyBulgarian,
    'privacy-norwegian': PrivacyPolicyNorwegian,
    'privacy-slovakian': PrivacyPolicySlovakian,
    'privacy-skenglish': PrivacyPolicySKEnglish,
    'privacy-swedish': PrivacyPolicySwedish,
    'privacy-romanian': PrivacyPolicyRomanian,
    'privacy-finnish': PrivacyPolicyFinnish
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/miximo/PrivacyPolicy.vue